import React, { useState } from "react";
import "./RequestDemo.scss";
import { Box, Button } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2/Grid2";
import RKTextField from "../../FieldTypes/RKTextField/RKTextField";
import TextArea from "../../FieldTypes/TextArea/TextArea";
import { ContactForm, countryCodeOption } from "../../../Service/Type/ContactForm";
import CustomButton from "../../CustomButton/CustomButton";
import SearchDropdown from "../../FieldTypes/SearchDropdown/SearchDropdown";
import { internationalMobileNumber, isEmpty, validateEmail } from "../../../SupportingFiles/HelpingFunctions";

interface formProps {
  formHeading: any;
  formDesc: string;
  formImg_url: string;
}

const RequestDemo: React.FC<formProps> = ({
  formHeading,
  formDesc,
  formImg_url,
}) => {

  const [isSubmitted, setIsSubmitted] = useState<boolean>(false);
  const [formFields, setFormFields] = useState<ContactForm>({
    name: { value: "", warning: false },
    email: { value: "", warning: false },
    organization: { value: "", warning: false },
    mobile: { value: "", warning: false },
    country: { value: "", warning: false },
    message: { value: "", warning: false },
  });

  const fieldsUpdateState = (attrName: any, value: string) => {
    setFormFields({
      ...formFields, [attrName[0]]: {
        value: value, warning: isEmpty(value)
      }
    })
  };

  const validateform = () => {
    let data = { ...formFields };
    data = {
      ...data,
      name: { ...data.name, warning: isEmpty(data.name.value) },
      email: { ...data.email, warning: !validateEmail(data.email.value) },
      organization: { ...data.organization, warning: isEmpty(data.organization.value) },
      mobile: { ...data.mobile, warning: !internationalMobileNumber(data.mobile.value, data.country.value) },
      country: { ...data.country, warning: isEmpty(data.country.value) },
      message: { ...data.message, warning: isEmpty(data.message.value) },
    }
    setFormFields({ ...data })

    let hasError = false;
    Object.values(data)?.map((item) => {
      if (item?.warning) {
        hasError = true;
      }
    })

    if (!hasError) {
      setIsSubmitted(true);
      formSubmit();
    }
  }

  const resetForm = () => {
    setIsSubmitted(false);
    setFormFields({
      name: { value: "", warning: false },
      email: { value: "", warning: false },
      organization: { value: "", warning: false },
      mobile: { value: "", warning: false },
      country: { value: "", warning: false },
      message: { value: "", warning: false },
    });
  }

  const formSubmit = () => {
    setTimeout(() => {
      setIsSubmitted(false);
      resetForm(); // Reset the form
    }, 2000);
  }

  return (
    <Box className="request_wrapper">
      <Grid container spacing={3} className="row">
        <Grid xs={12}>
          <div className="request_demo">
            <Grid container spacing={3}>
              <Grid sm={12} md={12} lg={6} className="text-md-center">
                <h6>{formHeading}</h6>
                <p>{formDesc}</p>
                <img src={formImg_url} alt="" />
              </Grid>
              <Grid sm={12} md={12} lg={6} className="pb-0">
                <div className="crm_formSection">
                  <Grid container rowSpacing={2.5}>
                    <Grid xs={12}>
                      <RKTextField
                        class_name="inputField "
                        title={"Name *"}
                        value={formFields.name.value}
                        attrName={["name"]}
                        value_update={fieldsUpdateState}
                        warn_status={formFields.name.warning}
                        error_messg="Please enter name"
                      />
                    </Grid>
                    <Grid xs={12}>
                      <RKTextField
                        class_name="inputField "
                        title={"Organization *"}
                        value={formFields.organization.value}
                        attrName={["organization"]}
                        value_update={fieldsUpdateState}
                        warn_status={formFields.organization.warning}
                        error_messg="Please enter organization"
                      />
                    </Grid>
                    <Grid xs={12}>
                      <SearchDropdown
                        class_name="inputField"
                        title={"Country *"}
                        value={formFields.country.value}
                        attrName={["country"]}
                        value_update={fieldsUpdateState}
                        warn_status={formFields.country.warning}
                        error_message="Please select country"
                        data={countryCodeOption}
                      />
                    </Grid>
                    <Grid xs={12}>
                      <RKTextField
                        class_name="inputField "
                        title={"Phone Number *"}
                        value={formFields.mobile.value}
                        attrName={["mobile"]}
                        maxLength={15}
                        value_update={fieldsUpdateState}
                        warn_status={formFields.mobile.warning}
                        error_messg={formFields.mobile.value ? "Please enter valid number" : "Please enter number"}
                        validation_type="NUMBER"
                      />
                    </Grid>
                    <Grid xs={12}>
                      <RKTextField
                        class_name="inputField"
                        title={"Email ID *"}
                        value={formFields.email.value}
                        attrName={["email"]}
                        value_update={fieldsUpdateState}
                        warn_status={formFields.email.warning}
                        error_messg="Please enter email"
                      />
                    </Grid>
                    <Grid xs={12}>
                      <TextArea
                        class_name="inputField "
                        title={"Message *"}
                        value={formFields.message.value}
                        placeholder={"Enter description here"}
                        attrName={["message"]}
                        value_update={fieldsUpdateState}
                        warn_status={formFields.message.warning}
                        error_messg="Please enter message"
                      />
                    </Grid>
                    <Grid xs={12} className="ctaBtn">
                      {isSubmitted ? (
                        <p style={{ color: 'green' }}>
                          Thanks for submitting data. We will reach you soon
                        </p>
                      ) : (
                        <CustomButton
                          class_name="blueXlBtn"
                          text_name={"Submit Details"}
                          onClickFunction={validateform}
                        />
                      )}
                    </Grid>
                  </Grid>
                </div>
              </Grid>
            </Grid>
          </div>
        </Grid>
      </Grid>
    </Box>
  );
};

export default RequestDemo;
